<nb-card>
  <nb-card-body>
    <nb-radio-group [(ngModel)]="masterCardSaveOption">
      @for (option of masterCardSaveOptions; track option.value) {
        <nb-radio class="ml-2" [value]="option.value">
          {{ option.label }}
        </nb-radio>
      }
    </nb-radio-group>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="primary" (click)="dismiss(masterCardSaveOption)" i18n="@@Save">Сохранить</button>
    &nbsp;
    <button nbButton status="basic" (click)="dismiss(null)" i18n="@@Cancel">Отмена</button>
  </nb-card-footer>
</nb-card>
